import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { useFela } from 'react-fela';

import Alert from 'antd/lib/alert';
import Button from 'antd/lib/button';

import { UserOutlined, LockOutlined } from '@ant-design/icons';

import { TextField } from '@ackee/mateus';

import { forms, formFields } from '../../services/config';

import rule from './LoginForm.rule';

const fields = formFields[forms.login];

const LoginForm = ({ handleSubmit, submitting, error }) => {
    const { css } = useFela();
    const intl = useIntl();
    return (
        <form onSubmit={handleSubmit} className={css(rule)}>
            {error && <Alert type="error" message={intl.formatMessage({ id: error })} />}
            <TextField
                prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                name={fields.email}
                placeholder={intl.formatMessage({ id: `login.form.${fields.email}.label` })}
            />
            <TextField
                type="password"
                prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                name={fields.password}
                placeholder={intl.formatMessage({ id: `login.form.${fields.password}.label` })}
            />
            <Button type="primary" htmlType="submit" loading={submitting}>
                <FormattedMessage id="login.form.submit" />
            </Button>
        </form>
    );
};

LoginForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    error: PropTypes.string,
};

LoginForm.defaultProps = {
    error: null,
};

export default LoginForm;
